
import React from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, Shield, UserPlus } from "lucide-react";

interface UserHeaderProps {
  onRefresh: () => void;
  onAddUser: () => void;
  isServiceRoleAvailable: boolean;
}

const UserHeader: React.FC<UserHeaderProps> = ({
  onRefresh,
  onAddUser,
  isServiceRoleAvailable
}) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-2xl font-bold">ניהול משתמשים</h2>
      <div className="space-x-2 flex">
        {!isServiceRoleAvailable && (
          <div className="flex items-center text-amber-500 ml-2">
            <Shield className="h-4 w-4 mr-1" /> מצב מוגבל
          </div>
        )}
        <Button onClick={onRefresh} variant="outline" size="sm">
          <RefreshCw className="h-4 w-4 ml-2" /> רענן
        </Button>
        <Button onClick={onAddUser} size="sm">
          <UserPlus className="h-4 w-4 ml-2" /> הוסף משתמש
        </Button>
      </div>
    </div>
  );
};

export default UserHeader;
